(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    const newsletterPopup=document.querySelector('[data-newsletter-popup]');
if(newsletterPopup){
  const success=newsletterPopup.dataset.success==='true';
  const dismissed=Number(localStorage.getItem('couturieristaNewsletterPopup')||0);
  if(success||Date.now()-dismissed>1209600000){setTimeout(()=>newsletterPopup.showModal(),success?150:5000)}
  newsletterPopup.querySelector('[data-newsletter-close]')?.addEventListener('click',()=>{localStorage.setItem('couturieristaNewsletterPopup',String(Date.now()));newsletterPopup.close()});
  newsletterPopup.addEventListener('click',event=>{if(event.target===newsletterPopup){localStorage.setItem('couturieristaNewsletterPopup',String(Date.now()));newsletterPopup.close()}});
  newsletterPopup.querySelector('[data-newsletter-code]')?.addEventListener('click',async event=>{await navigator.clipboard.writeText(event.currentTarget.dataset.newsletterCode);event.currentTarget.textContent='COPIED'});
}
  } catch(e) { console.error(e); }
})();

})();
